<template>
    <div v-if="!isTop" @click="scrollTotop" class="backto-top pointer" style="opacity: 1;"><i>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16"
                viewBox="0 0 16 16" fill="none">
                <g opacity="1" transform="translate(0 0)  rotate(0 8 8)">
                    <path id="圆形 1" fill-rule="evenodd" style="fill:#202020" transform="translate(0 0)  rotate(0 8 8)"
                        opacity="1"
                        d="M8,0C3.58,0 0,3.58 0,8C0,12.42 3.58,16 8,16C12.42,16 16,12.42 16,8C16,3.58 12.42,0 8,0Z ">
                    </path>
                    <g opacity="1"
                        transform="translate(4.27312319003363 4.256264831293095)  rotate(0 3.7268768099663134 4.284345704087254)">
                        <path id="矩形 1" fill-rule="evenodd" style="fill:#FFFFFF"
                            transform="translate(2.9307478947324626 0.9067596910778093)  rotate(0 0.8000000000000003 3.8309658585483497)"
                            opacity="1" d="M0,7.66L1.6,7.66L1.6,0L0,0L0,7.66Z "></path>
                        <path id="矩形 2" style="stroke:#FFFFFF; stroke-width:1.6; stroke-opacity:1; stroke-dasharray:0 0"
                            transform="translate(1.0888396747034221 1.094314215281031)  rotate(-45 2.6380371352628456 2.632562594685267)"
                            d="M0,0L5.28,0L5.28,5.27 "></path>
                    </g>
                </g>
            </svg>
        </i></div>
</template>

<script>
export default {
    data() {
        return {
            isTop: true,
            onscroll: null,
        }
    },
    mounted() {
        this.onscroll = function () {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 0) {
                if (this.isTop) this.isTop = false;
            } else {
                this.isTop = true;
            }
        }.bind(this);
        window.addEventListener("scroll", this.onscroll, true);
    },
    unmounted() {
        window.removeEventListener("scroll", this.onscroll);
    },
    methods: {
        scrollTotop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }
    }
}
</script>

<style scoped>
.backto-top {
    width: 16px;
    height: 16px;
    border-radius: 18px;
    position: fixed;
    right: 16px;
    background: rgb(255, 255, 255);
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 8px 0px;
    padding: 10px;
    box-sizing: content-box;
    opacity: 0;
    z-index: 100;
    bottom: 58px;
}
</style>